import Swiper, { Autoplay } from 'swiper/core';
import { debounce } from 'throttle-debounce';
import matchQuery from './utility/matchQuery';

Swiper.use([Autoplay]);

const element = document.querySelector('.swiper-container');

function setup() {
  if (matchQuery('md') && !element.swiper) {
    // eslint-disable-next-line no-new
    new Swiper(element, {
      speed: 600,
      centeredSlides: true,
      slidesPerView: 1400 / 836,
      spaceBetween: 40,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 4000,
      },
    });
  } else if (!matchQuery('md') && element.swiper) {
    element.swiper.detachEvents();
    element.swiper.destroy();
  }
}

// リサイズハンドラ
function resizeHandler() {
  setup();
}

export default function setupSlider() {
  if (element) {
    setup();

    window.addEventListener('resize', debounce(500, resizeHandler));
  }
}
